'use strict';

var processInclude = require('./base/util');

$(document).ready(function () {
    processInclude(require('./checkout/checkout'));
    processInclude(require('./components/storeDelivery'));
    processInclude(require('./checkout/favoriteStore'));
});
